import { memo, useEffect } from "react";
import { Button, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { mdlOtherAgency } from "../../models/domain/OtherAgency";
import { mdlVwOtherAgency } from "../../models/domain/VwOtherAgency";

export type OtherAgencyTableProps = {
    dataSource?: mdlVwOtherAgency[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
}

export const OtherAgencyTable = memo(function OtherAgencyTable(props: OtherAgencyTableProps) {
    const { t } = useTranslation();

    const columns: TableProps<mdlVwOtherAgency>['columns'] = [
        {
            title: t("definitions.otherAgencies.name"),
            dataIndex: 'agencyName',
            key: 'name'
        },
        {
            title: t("definitions.otherAgencies.phone"),
            key: 'phone',
            dataIndex: 'phone',
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" className="btn-success" onClick={() => props.onEdit ? props.onEdit(record.id) : undefined}>
                        {t("common.edit")}
                    </Button>
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleRowDoubleClick = (e: React.MouseEvent<HTMLInputElement>, agency: mdlVwOtherAgency) => {
        if (!$(e.target).hasClass("ant-table-row-expand-icon"))
            props.onEdit && props.onEdit(agency.id);
    }

    const handleTableChange: TableProps<mdlVwOtherAgency>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlVwOtherAgency>
                    onRow={(agency) => ({
                        onDoubleClick: (e) => handleRowDoubleClick(e, agency),
                    })}
                    onChange={handleTableChange}
                    size="middle"
                    columns={columns}
                    pagination={props.pagination}
                    scroll={{ x: 'max-content' }}
                    dataSource={props.dataSource.map((agency: mdlVwOtherAgency, index: number) => ({ ...agency, key: index }))}
                />
            }
        </>
    )
})